import { useQuery } from '@tanstack/react-query';
import type {
  CalculateCourseRefundableAmountRequest,
  CalculateCourseRefundableAmountResponse,
} from './interfaces';
import { falconClient } from '@/data/@clients';
import { baseUrl } from '@/data/subsidy/base';

export const useCalculateCourseRefundableAmount = (
  requestParams?: CalculateCourseRefundableAmountRequest,
  enabled?: boolean
) => {
  return useQuery<CalculateCourseRefundableAmountResponse>({
    queryKey: ['calculate-course-refundable-amount', requestParams],
    enabled: !!requestParams && enabled,
    queryFn: () =>
      falconClient.post(
        `${baseUrl}/policies/calculate_course_refundable_amount`,
        requestParams!
      ),
  });
};
